module.exports = __webpack_public_path__ + "img/johnoliver.93e12561.jpg";